/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Documents_Root_FolderInputs */

const cs_documents_root_folder = /** @type {(inputs: Documents_Root_FolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kořenová složka`)
};

const en_documents_root_folder = /** @type {(inputs: Documents_Root_FolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Root folder`)
};

/**
* | output |
* | --- |
* | "Root folder" |
*
* @param {Documents_Root_FolderInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_root_folder = /** @type {((inputs?: Documents_Root_FolderInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Root_FolderInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_documents_root_folder(inputs)
	return cs_documents_root_folder(inputs)
});